/* eslint-disable */
export function logger(...args) {
    if (process.env.VUE_APP_ENV === 'development'){
        console.log('-------- [ logger ]-----------');
        args.forEach((arg) => {
            console.log( ...arg);
        });
        console.log('-----------------------------');
    }
}
